import { FilterableColumn } from "../interfaces/FilterableColumn";

export function setActiveFilter(testSeriesId: number, activeFilters: Record<FilterableColumn, string[]>) {
  localStorage.setItem(`${testSeriesId}`, JSON.stringify(activeFilters));
}

export function getActiveFilter(testSeriesId: number): Record<FilterableColumn, string[]> {
  const filters = localStorage.getItem(`${testSeriesId}`);
  return filters ? JSON.parse(filters) : {};
}

export function removeActiveFilter(testSeriesId: number) {
  localStorage.removeItem(`${testSeriesId}`);
}
